import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';

const LocationsNav = (props) => {
    const { auth } = props;
    const { locations = {}, locationId = '', locationName = '' } = auth;

    const locationsArr = Object.keys(locations);

    return (
        locationsArr.length > 1 && (
            <Dropdown name="location" item text={locationName}>
                <Dropdown.Menu>
                    <Dropdown.Header>Location</Dropdown.Header>
                    {locationsArr.map((id) => (
                        <Dropdown.Item key={id} selected={id === locationId}>
                            {locations[id]}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        )
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps)(LocationsNav);
